import React, { PureComponent, Fragment } from 'react';
import Collapsible from 'react-collapsible';
import _includes from 'lodash/includes';

class Months extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      accordionOpen:true,
      accordiontransitionTime:300,
      activeFilter:[],
    }
  }

  static getDerivedStateFromProps(nextProps, prevState){
     if(nextProps.departureDates.length !== prevState.activeFilter.length){
        return {
          activeFilter:nextProps.departureDates
        }
     }
     return null;
  }

  onMonthClick(e, monthName, year){
    e.preventDefault();
     this.props.onSelect(monthName, year);
  }

  setActiveFilter(currentItem){
    return _includes(this.state.activeFilter, currentItem) ? 'active-filter' : "";
  }

  showComma(index, arr){
    return (index === arr.length - 1 ) ? " " : ",";
  }

  limitChar(str, limit){
    if(str.length >= limit) {
      return str = str.substring(0,limit);
    }
  }

  renderCollapsible(){

    const _year = new Date().getFullYear();
    const _nextYear = new Date().getFullYear() + 1;
    const { accordionOpen, accordiontransitionTime } = this.state;
    const { months, nextYearMonths } = this.props;

    return (
       <Collapsible
         trigger="Departure by Month"
         open={accordionOpen}
         transitionTime={accordiontransitionTime}>
         <p className="yearLabel">{_year}</p>
          {
            months.map((item, i) => {
              return <a
                key={`${item}`}
                href=""
                className={ `monthTag ${this.setActiveFilter(" " + item + " " +_year)}` }
                onClick={e => this.onMonthClick(e, `${item}`, `${_year}` )}>{ item + this.showComma(i, months) }
              </a>
            })
          }
          <br />
          <br style={{display:nextYearMonths.length > 0 ? 'block' : 'none'}} />
          <p className="yearLabel" style={{display:nextYearMonths.length > 0 ? 'block' : 'none'}}>{_nextYear}</p>
          {
            nextYearMonths.map((item, i) => {
              return <a
                key={`${item}`}
                href=""
                className={ `monthTag no-padding-bottom ${this.setActiveFilter(" " + item + " " +_nextYear)}` }
                onClick={e => this.onMonthClick(e, `${item}`, `${_nextYear}` )}>{ item + this.showComma(i, nextYearMonths) }
              </a>
            })
          }
      </Collapsible>
    )
  }

  renderOptionsMenu(){

    const _year = new Date().getFullYear();
    const _nextYear = new Date().getFullYear() + 1;
    const { months, nextYearMonths } = this.props;

    return (
      <div className="options-menu-months">
      <p className="subtitle">Departures in {_year}</p>
       {
         months.map((item, i) => {
           if(i === 5){
             return (
               <Fragment key={`${item}`}>
                  <a
                    href=""
                    className={ `monthTag ${this.setActiveFilter(" " + item + " " +_year)}` }
                    onClick={e => this.onMonthClick(e, `${item}`, `${_year}` )}>{ this.limitChar(item,3) + this.showComma(i, months) }
                  </a>
                  <br />
               </Fragment>
             )
           }else{
            return <a
              key={`${item}`}
              href=""
              className={ `monthTag ${this.setActiveFilter(" " + item + " " +_year)}` }
              onClick={e => this.onMonthClick(e, `${item}`, `${_year}` )}>{ this.limitChar(item,3) + this.showComma(i, months) }
            </a>
           }
         })
       }
       <br />
       <br />
       <p className="subtitle">Departures in {_nextYear}</p>
       {
         nextYearMonths.map((item, i) => {
           return <a
             key={`${item}4${Math.random()+5000}`}
             href=""
             className={ `monthTag ${this.setActiveFilter(" " + item + " " +_nextYear)}` }
             onClick={e => this.onMonthClick(e, `${item}`, `${_nextYear}` )}>{ this.limitChar(item,3) + this.showComma(i, nextYearMonths) }
           </a>
         })
       }
       </div>
    )
  }

  render(){
    return (
      <Fragment>
        { this.props.type === "no-collapse" ? this.renderOptionsMenu() : this.renderCollapsible() }
      </Fragment>
    )
  }
}

export default Months;



// WEBPACK FOOTER //
// ./src/components/tripSearch/filters/components/months.js